import { scalar } from '../ability/context.js';

// Shared by trade/training and campaign labels; keep one set of economic bands.
export const effectiveFavor = (v: unknown): number => v == null || v === '' ? 50
  : Math.max(0, Math.min(100, Math.trunc(Number(scalar(v) ?? 0) || 0)));

export function favorTier(f: number): string {
  return f <= 0 ? 'Hated — total gouge' : f < 10 ? 'Hostile — severe markup' : f < 30 ? 'Unfriendly — barely tolerated'
    : f < 60 && f !== 50 ? 'Cool to neutral' : f === 50 ? 'Neutral — standard medieval merchant' : f < 70 ? 'Neutral to warm'
    : f < 90 ? 'Friendly — regular customer' : f < 95 ? 'Favored — solid discount' : 'Beloved — VIP, best deals';
}
